import { createVanIconComponent } from "./van"

const Paid = createVanIconComponent("paid")
export default Paid
